import React, {useEffect, useState} from "react";
import DataTable from 'react-data-table-component';
import {useDispatch, useSelector} from "react-redux";
import {getAllTransactions, filterOrdersByDate} from "../../redux/actions/transactions";
import TransactionsListExcel from "./TransactionsListExcel";
import Loading from "../../components/Loading";
import FilterByDate from './components/FilterByDate'
import MessagesList from '../dashboard/components/messages/MessagesList'

const columns = [
    {
        name: '#',
        selector: 'id',
        sortable: false,
        left: true,
        width:'10%'
    },
    {
        name: 'مبلغ',
        selector: 'amount',
        sortable: false,
        left: true,
        width:'15%'
    },
    {
        name: 'کد سفارش',
        selector: 'orderId',
        sortable: false,
        left: true,
        width:'10%'
    },
    {
        name: 'توضیحات',
        selector: 'comment',
        sortable: false,
        left: true,
        width:'40%'
    },
    {
        name: 'تاریخ ایجاد',
        selector: 'jalali_created_at',
        sortable: false,
        left: true,
        width:'20%'
    }
];
const Transactions = (props) => {
    const dispatch = useDispatch();
    const {all_transactions_success,all_transactions_waiting} = useSelector(state => state.transactions);
    const {filter_transactions_success,filter_transactions_waiting} = useSelector(state => state.transactions);
    const [totalItems, setTotalItems] = useState(10);
    const [transactions,setTransactions] = useState([]);
    const [transactionsTotal,setTransactionsTotal] = useState([]);
    const [message, setMessage] = useState({})
    const [filterState, setFilterState] = useState(false)
    const [excelUrl , setExcelUrl] = useState('')
    const [query,setQuery] = useState({
        page : 1,
        per_page : 10
    });
    useEffect(() => {
         dispatch(getAllTransactions(query));
    },[query]);

    useEffect(() => {
        if (all_transactions_success.result && all_transactions_success.result === 'SUCCESS'){
            setTransactions(all_transactions_success.data.transactions);
            setTotalItems(all_transactions_success.data.total)
        }
    },[all_transactions_success]);

    function handleSort() {

    }

    useEffect(() => {
        if (filter_transactions_success.result && filter_transactions_success.result === 'SUCCESS'){
            setExcelUrl(filter_transactions_success.data.url)
            setFilterState(true)
        }
    },[filter_transactions_success]);

    function handleChangePerPage(perPage) {
        setQuery({
            per_page: perPage,
            page: 1
        })
    }

    function handleChangePage(page) {
        setQuery((prevState) => ({
            ...prevState,page: page
        }))
    }

    const setFilterDate = async (start,end) => {
        if(start !== null && end !== null && start !== undefined && end !== undefined){
            setMessage({
                show: false,
                message: []
            })
            const checkNumUnderTen = (num) => {
                if(num < 10) {
                    return `0${num}`
                } else {
                    return num
                }
            }
            const dateMomentStart = `${start.year}/${checkNumUnderTen(start.month)}/${checkNumUnderTen(start.day)}`
            const dateMomentEnd = `${end.year}/${checkNumUnderTen(end.month)}/${checkNumUnderTen(end.day)}`
            const date ={
                from: dateMomentStart,
                to: dateMomentEnd
            }
            await dispatch(filterOrdersByDate({...date}))
        } else {
            setMessage({
                show: true,
                message: [{
                    type: "danger",
                    message: "لطفا تاریخ معتبری وارد نمایید."
                }]
            })
        }
    }

    return(
        <div className="row">
            {filterState && excelUrl !=='' && (
                <div className="col-lg-12 col-md-12 page-header">
                    گزارش تراکنش‌ها
                    <a href={excelUrl} target="_blank" className="btn btn-sm btn-success btn-export">دانلود خروجی اکسل</a>
                    {/* <TransactionsListExcel transactions={transactions} /> */}
                </div>
            )
            }
            {
                all_transactions_waiting ? <Loading /> :
                    <div className="col-lg-12 col-md-12 table-holder">
                        <FilterByDate setFilterDate={(startDate, endDate) => {setFilterDate(startDate, endDate)}}  removeFilterDate = {() => {
                            setQuery({
                                page : 1,
                                per_page : 10
                            })
                            setFilterState(false)
                            }}/>
                        {Object.keys(message).length !== 0 && message !== null && message !== undefined && (<MessagesList messages={message.message}/>)}
                        <DataTable
                            noHeader={true}
                            className="main-table shadow-sm"
                            columns={columns}
                            data={transactions}
                            persistTableHead={true}
                            keyField='id'
                            striped={true}
                            highlightOnHover={true}
                            pointerOnHover={true}
                            noDataComponent={<div>موردی یافت نشد!</div>}
                            pagination
                            paginationServer
                            paginationTotalRows={all_transactions_success.data ? all_transactions_success.data.total : 0}
                            paginationDefaultPage={all_transactions_success.data ? all_transactions_success.data.page : 1}
                            paginationPerPage={all_transactions_success.data ? all_transactions_success.data.per_page : 10}
                            onChangePage={handleChangePage}
                            paginationComponentOptions={{
                                rowsPerPageText: 'رکورد در صفحه :',
                                rangeSeparatorText: 'از',
                                noRowsPerPage: false,
                                selectAllRowsItem: false,
                                selectAllRowsItemText: 'همه'
                            }}
                            onChangeRowsPerPage={handleChangePerPage}
                            onSort={handleSort}
                            sortServer
                            defaultSortField={'id'}
                            defaultSortAsc={false}
                            expandableRows={false}
                            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 200]}
                        />
                    </div>
            }
        </div>
    )
}

export default Transactions;
